import axiosIns from '@/plugins/axios'

export default {
  // 再送候補（failed + 完了通知が来ていない sent）の一覧
  getPrintTickets() {
    return axiosIns.get('/waiter/print_tickets')
  },

  // 対象チケットを pending に戻し、次回ポーリングで再印刷させる
  resendPrintTicket(id) {
    return axiosIns.post(`/waiter/print_tickets/${id}/resend`)
  },
}
